class HMediaNavigator extends HTMLElement {
  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
    this.style.position = 'absolute'
    this.style.top = '50%'
    const right = () => this.style.right = innerWidth > 750 ? '0' : '10px'
    this.style.transform = "translateY(-50%)"

    const observer = new MutationObserver(e => e.forEach(() => {
      this.style.width = `${this.previousElementSibling.offsetWidth}px`
    }))
    observer.observe(this.parentElement, { childList: true, subtree: true, attributes: true })

    this.shadowRoot.innerHTML = `
    <style>
      .wrapper {
        display: flex;
        justify-content: space-between;
      }
      .h-media-navigator__button {
        background: transparent;
        border: 0;
        color: #fff;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0,0,0,.5);

      }
      .h-media-navigator__button svg {
        display: block;
        line-height: 1;
        width: 40px;
        height: 40px;
      }
    </style>
    <div class="wrapper">
      <button class="h-media-navigator__button h-media-navigator__button--prev">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <button class="h-media-navigator__button h-media-navigator__button--next">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    `

    right()
    window.addEventListener('resize', right)

  }
  connectedCallback() {
    if (!this.isConnected) return

    const prev = this.shadowRoot.querySelector(".h-media-navigator__button--prev")
    const next = this.shadowRoot.querySelector(".h-media-navigator__button--next")

    prev.addEventListener("click", e => {
      e.preventDefault()
      e.stopPropagation()
      const selected = document.querySelector('.product-gallery--image-thumbnail[data-gallery-selected="true"]')

      selected.parentElement.style.setProperty('scroll-behavior', 'initial')

      const prev = selected.previousElementSibling || selected.parentElement.querySelector(".product-gallery--image-thumbnail:last-child")
      if (!prev) return
      prev.click()
      const top = prev.offsetTop
      prev.parentElement.scrollTop = top
    })

    next.addEventListener("click", e => {
      e.preventDefault()
      e.stopPropagation()
      const selected = document.querySelector('.product-gallery--image-thumbnail[data-gallery-selected="true"]')

      selected.parentElement.style.setProperty('scroll-behavior', 'initial')


      const next = selected.nextElementSibling || selected.parentElement.querySelector(".product-gallery--image-thumbnail:first-child")
      if (!next) return
      next.click()
      const top = next.offsetTop
      next.parentElement.scrollTop = top
    })
  }
}
if (!customElements.get("h-media-navigator")) {
  customElements.define("h-media-navigator", HMediaNavigator)
}